'use client'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAnchor, faArrowRight, faLock } from '@fortawesome/pro-solid-svg-icons'
import { Button } from '@teqplay/ui'
import { useState } from 'react'

import ModalPortPerformance from '../../Modals/ModalPortPerformance'

import { TVesselJourneyResponse } from '@/api/v1/resources/vesselJourney'

import './PortArrivalKPI.scss'

type TProps = {
  vessel: TVesselJourneyResponse
}

const STAGES = [
  'Anchorage & drifting',
  'Steaming in',
  'Moored duration',
  'Shifting',
  'Steaming out'
]

function LockedValue() {
  return (
    <div className="locked-value">
      <FontAwesomeIcon icon={faLock} className="lock-icon" />
      <span className="redacted" />
      <span className="unit">h</span>
      <span className="redacted" />
      <span className="unit">m</span>
    </div>
  )
}

export default function PortArrivalKPI({ vessel }: TProps) {
  const portName = vessel.arrival?.port?.name
  const unlocode = vessel.arrival?.port?.unlocode

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  if (!portName && !unlocode) return null

  return (
    <section className="vessel-port-arrival-kpi">
      <div className="port-arrival-kpi">
        <div className="title">
          <h3>
            <FontAwesomeIcon icon={faAnchor} />
            <span>Port of Arrival</span>
          </h3>
          <Button variant="brand-primary" onClick={() => setIsModalOpen(true)}>
            <span>Discover port KPI</span>
            <FontAwesomeIcon icon={faArrowRight} />
          </Button>
          <ModalPortPerformance isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
        </div>

        <div className="port-info">
          <div className="port-image-gradient" aria-hidden="true" />
          <div className="port-meta">
            <div className="port-name">{portName ?? '-'}</div>
            <div className="port-unlocode">{unlocode ?? '-'}</div>
          </div>
        </div>

        <div className="pto-row">
          <span className="pto-label">Port Turnaround Time (hrs)</span>
          <LockedValue />
        </div>

        <div className="stages">
          <div className="stages-label">Stages</div>
          {STAGES.map((stage) => (
            <div className="stage-item" key={stage}>
              <span className="stage-name">{stage}</span>
              <LockedValue />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
